/**
 * @file stringHelpers.ts
 *
 * @fileoverview Helper functions to manipulate strings..
 */

/**
 * Transform a string into camelCase.
 *
 * @param str
 *  The string to be converted.
 *
 * @return {string}
 *  The string in camelCase.
 */
export const camelCase = (str: string): string => {
  return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (match, chr) => {
    return chr.toUpperCase();
  });
};

/**
 * Transforms a camelcase string to a title.
 *
 * @param {string} camelCaseStr
 *  The string to convert.
 */
export const camelToTitle = (camelCaseStr: string): string =>
  camelCaseStr
    .replace(/([A-Z0-9])/g, (match) => ` ${match}`)
    .replace(/^./, (match) => match.toUpperCase())
    .trim();

/**
 * Transforms a camelcase string to lower case with spaces.
 *
 * @param {string} camelCaseStr
 *  The string to convert.
 */
export const camelToLower = (camelCaseStr: string): string =>
  camelCaseStr
    .replace(/([A-Z0-9])/g, (match) => ` ${match}`)
    .toLowerCase()
    .trim();

/**
 * Transforms a camelcase string to lower case with spaces.
 *
 * @param {string} camelCaseStr
 *  The string to convert.
 */
export const camelToSnakeCase = (camelCaseStr: string) =>
  camelCaseStr.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

/**
 * Transforms an object with keys like "field_name_of_item" to "nameOfItem" to be used
 * inside graphql mutations.
 *
 * @param {object} data
 *   The data to be transformed. Can be any kind of object.
 */
export const objectKeysCamelCase = (data: object) => {
  const newObject = {};
  Object.keys(data).forEach((key) => {
    const value = data[key];
    newObject[camelCase(key.replace('field_', ''))] = value;
  });
  return newObject;
};
